// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  flagId: __t.string().primaryKey(),
  lobbyId: __t.string(),
  teamId: __t.i32(),
  homePosX: __t.i32(),
  homePosY: __t.i32(),
  posX: __t.i32(),
  posY: __t.i32(),
  state: __t.string(),
  carrierId: __t.string(),
  droppedAtSequence: __t.u32(),
  lastReturnedSequence: __t.u32(),
  updatedAt: __t.timestamp(),
});
